<form [formGroup]="formName">
  <div *ngIf="field.type === 'date'">
    <mat-form-field appearance="outline" [ngStyle]="{'width.px': 264}">
      <mat-label>{{field.label | uppercase}}</mat-label>
      <input [formControlName]="field.filterKey" [matDatepicker]="picker" matInput>
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <div *ngIf="field.type === 'date_range'">
    <mat-form-field appearance="outline" [ngStyle]="{'width.px': 264}">
      <mat-label>{{field.label | uppercase}}</mat-label>
      <mat-date-range-input [rangePicker]="picker" [formGroupName]="field.filterKey">
        <input matStartDate formControlName="start" placeholder="{{'common.start_date' | translate}}">
        <input matEndDate formControlName="end" placeholder="{{'common.end_date' | translate}}">
      </mat-date-range-input>
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <div *ngIf="field.type !== 'date' && field.type !== 'date_range'" [ngStyle]="{'width.px': 168}">
    <mat-form-field appearance="outline">
      <mat-label>{{field.label | uppercase}}</mat-label>
      <input [formControlName]="field.filterKey" [name]="field.label" [type]="field.type" [value]="field.value"
        matInput>
    </mat-form-field>
  </div>
</form>
